export interface PanoramaState {
  yaw: number;
  pitch: number;
  zoom: number;
}

export interface LayerFeatureGeometry {
  readonly type?: string;
  readonly x?: number;
  readonly y?: number;
  readonly spatialReference?: {
    readonly wkid?: number;
    readonly latestWkid?: number;
  };
  readonly extent?: {
    readonly center?: {
      readonly x?: number;
      readonly y?: number;
      readonly type?: string;
      readonly spatialReference?: {
        readonly wkid?: number;
        readonly latestWkid?: number;
      };
    };
  };
}

export type LayerFeatureAttributes = Record<string, unknown>;

export interface LayerFeature {
  filePath: string;
  imageType: 'STATIC' | 'PANO';
  order: number;
  imageIndex: number | null;
  spatialIndex?: number | null;
  geometry: LayerFeatureGeometry | null;
  attributes: LayerFeatureAttributes;
}

export type SyncMode = 'image' | 'spatial';

export const IMAGE_VIEWER_DEFAULT_POSITION = {
  x: 80,
  y: 90,
} as const;
export const IMAGE_VIEWER_CASCADE_OFFSET_PX = 30;

export interface ImageViewerInstance {
  id: string;
  surveySlug: string;
  surveyLabel: string;
  layerKey: string;
  layerName: string;
  layerRef: unknown;
  currentFilePath: string;
  imageType: 'STATIC' | 'PANO';
  isActive: boolean;
  isSynced: boolean;
  syncGroupId: string | null;
  isMinimized: boolean;
  position: { x: number; y: number };
  panoramaState: PanoramaState | null;
  sequentialIndex: number;
  layerFeatures: LayerFeature[];
  isLoading: boolean;
  hasError: boolean;
  noImageAvailable: boolean;
  zIndex: number;
}

export interface SyncGroup {
  id: string;
  surveySlug: string;
  viewerIds: string[];
  syncMode: SyncMode;
  focusViewerId: string | null;
  limitMessage: string | null;
}

/** Colours applied to synced modal outlines so grouped viewers are visually distinct. */
export const SYNC_GROUP_COLORS = [
  '#3A86FF', // blue
  '#8338EC', // violet
  '#06D6A0', // mint
  '#FB8500', // deep orange
  '#E63946', // red
];
